<template>
    <Spinner class="center pv3"  size="huge" line-fg-color="#000" line-bg-color="#fb0" />
</template>

<script>
import Spinner from 'vue-simple-spinner';

export default {
    components: {
        Spinner
    }
};
</script>
